import * as types from './types';

const initialState = {
  isAppLoading: false,
  userDetails: undefined,
  organisationList: [],
  notificationList: [],
  isInit: false,
  isAuthLoading: false,
  organization: undefined,
  isAddingNewMembers: false,
  isSuperUser: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case types.SET_USER_DATA:
    case types.SET_GUEST:
    case types.SET_AUTH_LOADING_STATE:
    case types.LOCAL_AUTH:
    case types.SET_ORGANIZATION:
    case types.UPDATE_USER_DETAILS:
    case types.SET_IS_ADDING_NEW_MEMBERS:
    case types.SET_IS_SUPER_USER:
      return {
        ...state,
        ...payload,
      };
    case types.SET_EMAIL_VERIFIED:
      return {
        ...state,
        userDetails: {
          ...state.userDetails,
          isEmailVerified: false,
        },
      };
    default:
      return state;
  }
}
